import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "quick-cart" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "quick-cart__empty"
}
const _hoisted_4 = {
  key: 1,
  class: "quick-cart__list-wrapper"
}
const _hoisted_5 = { class: "quick-cart__list" }
const _hoisted_6 = {
  key: 2,
  class: "quick-cart__summary"
}
const _hoisted_7 = { class: "quick-cart__order-total" }
const _hoisted_8 = {
  key: 0,
  class: "quick-cart__to-checkout"
}

import { ref, computed, watch } from 'vue';

import useUser from '@/composables/useUser';
import useContext from '@/composables/useContext';
import useWebsiteTexts from '@/composables/useWebsiteTexts';
import useEventListener from '@/composables/useEventListener';

import DrawerLayer from '@distancify-storefront/ui-drawer-layer';
import CartItem from './CartItem.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'QuickCart',
  setup(__props) {

const {
  settings,
  resolveLink,
  page,
  cart,
  route,
  formatPrice,
  navigate,
  channel,
  navigateToLoginPage,
} = useContext();
const { user } = useUser();
const { websiteText } = useWebsiteTexts();
const { useEmitterEventListener } = useEventListener();

const isQuickCartOpened = ref(false);

const cartIsEmpty = computed(() => {
  return cart.value?.isEmpty || false;
});

const cartItemCount = computed(() => {
  return (cart.value?.rows || []).reduce(
    (acc: number, curr: any) => acc + +curr.quantity,
    0
  );
});

const rows = computed(() => {
  return cart.value?.rows || [];
});

const totalLabel = computed(() => {
  const total = websiteText('cart__total').value;
  const oneProduct = websiteText('cart__total_one_product').value;
  if (cartItemCount.value == 1) {
    return `${total} (${oneProduct})`;
  } else if (cartItemCount.value > 1) {
    const multipleProducts = websiteText('cart__total_multiple_products', {
      products: cartItemCount.value,
    }).value;
    return `${total} (${multipleProducts})`;
  }
  return '';
});

const grandTotal = computed(() => {
  return cart.value?.grandTotal || 0;
});

watch(
  () => page.value,
  () => {
    isQuickCartOpened.value = false;
  }
);

async function openQuickCart() {
  if (user.value?.isAuthenticated) {
    isQuickCartOpened.value = true;
  } else {
    navigateToLoginPage();
  }
}

const checkoutUrl = computed(() => {
  return (
    resolveLink(() => settings.value?.checkout)?.url || channel.value?.rootPath
  );
});

async function goToCheckout() {
  try {
    navigate(checkoutUrl.value);
    localStorage.setItem('checkoutPreviousRoute', route.fullPath);
  } catch (e) {
    console.error(e);
    navigate(channel.value.rootPath);
  }
}

useEmitterEventListener('openQuickCart', openQuickCart);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(DrawerLayer), {
    modelValue: isQuickCartOpened.value,
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isQuickCartOpened).value = $event)),
    showCloseIcon: true,
    containerClass: "quick-cart__modal-container"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h2", {
          class: _normalizeClass(["quick-cart__title", { 'quick-cart__title-empty--phone': _unref(cartIsEmpty) }])
        }, [
          _createTextVNode(_toDisplayString(_unref(websiteText)('cart__title').value) + " ", 1),
          (_unref(cartItemCount))
            ? (_openBlock(), _createElementBlock("span", _hoisted_2, "(" + _toDisplayString(_unref(cartItemCount)) + ")", 1))
            : _createCommentVNode("", true)
        ], 2),
        (_unref(cartIsEmpty))
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_unref(websiteText)('global__label_empty_cart').value), 1))
          : _createCommentVNode("", true),
        (!_unref(cartIsEmpty))
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rows), (row) => {
                  return (_openBlock(), _createBlock(CartItem, {
                    key: row.id,
                    row: row
                  }, null, 8, ["row"]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true),
        (!_unref(cartIsEmpty))
          ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("div", null, _toDisplayString(_unref(totalLabel)), 1),
                _createElementVNode("div", null, _toDisplayString(_unref(formatPrice)(_unref(grandTotal))), 1)
              ]),
              (_unref(checkoutUrl))
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("button", {
                      class: "primary-button quick-cart__to-checkout-btn",
                      onClick: goToCheckout
                    }, _toDisplayString(_unref(websiteText)('cart__to_checkout').value), 1)
                  ]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})